import { forwardRef } from "react";

import { useField, useFormikContext, getIn } from "formik";
import { dissoc } from "ramda";

import { Select, SelectProps } from "src/components/Select";

export type FormikSelectProps = SelectProps & {
  /** Formik field name. */
  name: string;
};

const FormikSelect = forwardRef<HTMLInputElement, FormikSelectProps>(
  (props, ref) => {
    const { name, onOpenChange, onChange: onChangeProp, ...otherProps } = props;
    const [field, meta, { setValue, setTouched }] = useField(name);
    const { status = {}, setStatus } = useFormikContext();
    const fieldStatus = getIn(status, name);

    const selectProps = {
      ...otherProps,
      ref,
      error: meta.touched ? meta.error || fieldStatus : "",
      name: field.name,
      value: field.value,
      onOpenChange: (open: boolean) => {
        if (!open) setTouched(true, false);
        onOpenChange?.(open);
      },
      onChange: (value: unknown) => {
        setStatus(dissoc(name, status));
        setValue(value);
        (onChangeProp as ((v: unknown) => void) | undefined)?.(value);
      },
    };

    return <Select {...(selectProps as SelectProps)} />;
  }
);

FormikSelect.displayName = "FormikSelect";

export { FormikSelect };
